import React from 'react';
import Reveal from '../components/Reveal';
import SkillGauge from '../components/SkillGauge';

function Resume({ data }) {
  if (!data) return null;

  const { skillmessage, education, work, skills } = data;

  return (
    <section id="resume">

      <div className="row section">
        <div className="three columns header-col">
          <h1><span>Education</span></h1>
        </div>
        <Reveal as="div" className="nine columns main-col resume-card">
          {education.map((edu) => (
            <div key={edu.school}>
              <h3>{edu.school}</h3>
              <p className="info">{edu.degree} <span>&bull;</span><em className="date">{edu.graduated}</em></p>
              <p>{edu.description}</p>
            </div>
          ))}
        </Reveal>
      </div>

      <div className="row section">
        <div className="three columns header-col">
          <h1><span>Work</span></h1>
        </div>
        <Reveal as="div" className="nine columns main-col resume-card">
          {work.map((job) => (
            <div key={job.company}>
              <h3>{job.company}</h3>
              <p className="info">{job.title}<span>&bull;</span> <em className="date">{job.years}</em></p>
              <p>{job.description}</p>
            </div>
          ))}
        </Reveal>
      </div>

      <div className="row section">
        <div className="three columns header-col">
          <h1><span>Skills</span></h1>
        </div>
        <Reveal as="div" className="nine columns main-col resume-card">
          <p>{skillmessage}</p>
          <div className="skill-gauges">
            {skills.map((skill) => (
              <SkillGauge key={skill.name} name={skill.name} level={skill.level} />
            ))}
          </div>
        </Reveal>
      </div>

    </section>
  );
}

export default Resume;
